var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfNextOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84105 11.7797C6.63422 11.9088 6.43122 11.9171 6.23207 11.8047C6.03292 11.6923 5.93335 11.516 5.93335 11.2759V4.63363C5.93335 4.40457 6.03292 4.23384 6.23207 4.12145C6.43122 4.00905 6.63422 4.01738 6.84105 4.14645L12.0602 7.4823C12.2448 7.60026 12.3371 7.76051 12.3371 7.96307C12.3371 8.16563 12.2448 8.32589 12.0602 8.44383L6.84105 11.7797Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfNextOne);
export default __webpack_public_path__ + "static/media/pdf-next-one.9d48b5c3d0e0ba6973ea4d6ea97d6142.svg";
export { ForwardRef as ReactComponent };